import { ganttDayPathFormat } from '@components/Schedule/Gantt/gantt.constants';
import { format as originalFormat } from 'date-fns';
import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import { ROUTE_SCHEDULE } from '../routes';

export const useGoToSchedule = () => {
    const navigate = useNavigate();
    return useCallback(
        (date: Date) => {
            navigate(ROUTE_SCHEDULE.replace(':date', originalFormat(date, ganttDayPathFormat)));
        },
        [navigate],
    );
};
